import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import AddIcon from '@atlaskit/icon/core/add';
import { Box, Flex, xcss } from '@atlaskit/primitives';

const plusButtonContainerStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	width: '100%',
});

const lineStyles = xcss({
	flexGrow: 1,
	flexShrink: 1,
	flexBasis: '0%',
	height: '1px',
	backgroundColor: 'color.background.neutral',
});

const Line = () => <Box xcss={lineStyles} />;

export const PlusButton = ({ onClick }: { onClick: (event: React.MouseEvent) => void }) => {
	return (
		<Flex xcss={plusButtonContainerStyles}>
			<Line />
			<IconButton
				isTooltipDisabled={false}
				shape="circle"
				icon={AddIcon}
				label="Add section"
				onClick={onClick}
			/>
			<Line />
		</Flex>
	);
};
